import { Card } from 'antd';
import { CardInfo, CardTitle } from './CardDataDisplay';
import ChangeDeviceLocationFromInstallation from '../../device/ChangeDeviceLocationFromInstallation';
import EditInstallation from '../../installation-location/InstallationLocationDetail/EditInstallation';
import useAuthStore from '../../../stores/auth.store';

interface DataItem {
  id: string;
  title: string;
  data: string;
  color?: string;
  onSave?: (val: number) => Promise<void>;
}

interface InfoCardProps {
  data: DataItem[];
  title: string;
  isDevices?: boolean;
  installationUuid?: string;
  onSuccess?: () => void;
  adminUuid?: string;
}

const siphonString = 'siphon';

const InfoCard = ({ data, title, isDevices, installationUuid, onSuccess, adminUuid }: InfoCardProps) => {
  const isSuperAdminOrCompanyAdmin = useAuthStore((state) => state.isSuperAdminOrCompanyAdmin);
  const userUuid = useAuthStore((state) => state.uuid);
  const isAdmin = useAuthStore((state) => state.isAdmin);

  const isAdminOfLocation = isAdmin && adminUuid === userUuid;

  return (
    <Card>
      <CardTitle title={title} />
      {data.map((item) => (
        <CardInfo
          key={item.id}
          label={item.title}
          data={item.data}
          id={item.id}
          color={item.color}
          onSave={item.onSave}
        />
      ))}
      {isDevices && isSuperAdminOrCompanyAdmin && <ChangeDeviceLocationFromInstallation onSuccess={onSuccess} />}
      {!isDevices && (isSuperAdminOrCompanyAdmin || isAdminOfLocation) && (
        <EditInstallation uuid={installationUuid} areaToEdit={siphonString} onSuccess={onSuccess} />
      )}
    </Card>
  );
};

export default InfoCard;
